import { StyleConfig } from "@chakra-ui/react";

export const Spinner: StyleConfig = {
  baseStyle: {
    color: "blue.500",
  },
};
